import React from "react";
import PropTypes from "prop-types";

export default function Tag({ label, ...props }) {
  return <div className="Tag" {...props}>{label}</div>;
}

Tag.propTypes = {
  label: PropTypes.string,
};
